// extracted by mini-css-extract-plugin
export default {"form":"SettingsForm_form__Fpzru"};